:host {
  display: block;
}

.component-form {
  display: grid;
  flex-direction: column;
  gap: 0.5rem;
}

.component-field-container {
  display: grid;
  grid-template-columns: 10em 1fr 20px;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.component-button {
  padding: 0.75rem 1.5rem;
  background-color: var(--theme-button-color, #007bff);
  color: var(--theme-primary-color, #fff);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  width: fit-content;
}

.component-button:disabled {
  background-color: var(--theme-button-color-disabled, #ccc);
  cursor: not-allowed;
}

.component-button:hover:not(:disabled) {
  background-color: var(--theme-button-color-hover, #0056b3);
}

/* Ensure individual field components stack vertically */
securecall-request-radio,
securecall-request-currency,
securecall-request-string,
securecall-request-secure-pan,
securecall-request-secure {
  display: block;
  width: 100%;

}

.field-container {
  display: grid;
  grid-template-columns: 10em 1fr 20px;
  align-items: center;
  gap: 1rem;
}

.custom-label {
  text-align: right;
  align-items: center;
  font-weight: bold;
  gap: 0.5rem;
}

.custom-input {
  padding: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
